// extracted by mini-css-extract-plugin
module.exports = {"button":"TwireButton_button__22_J2","blue":"TwireButton_blue__1bONb","red":"TwireButton_red__1olaD","loadingSvg":"TwireButton_loadingSvg__2MpJA"};